<template>
    <div>
        <div v-show="!childShow">
            <table-title>筛选框</table-title>
            <Form :model="queryParams" inline :label-width="100">
                <!-- <FormItem label="参与人">
                    <dict-select namespace="bizObjects" id="member" :exclusion="[]" v-model="queryParams.memberId" />
                </FormItem> -->
                <FormItem label="标的物小类">
                    <target-type-select  v-model="queryParams.targetType" />
                </FormItem>
                <Button type="primary" @click="search">查询</Button>
                <Button type="success" style="margin-left:10px" v-show="confirmButton" @click="onAddFrameRentEnt">新增</Button>
            </Form>
            <table-title>租赁框架协议列表</table-title>
            <data-grid ref="lg" :columns="frameRentCols" :queryParams="queryParams" :queryUrl="queryUrl" paramsName="params" subListName :dataList="[]">
                <template #default="{columns, data}">
                    <Table :columns="columns" :data="data" border stripe size="small" style="margin:10px">
                        <template slot-scope="{row}" slot="id">
                            <a href="javascript:;" class="hoverCollection" style="color: #2d8cf0" @click="goDetail(row.id)">{{row.id}}</a>
                        </template>
                    </Table>
                </template>
            </data-grid>
            <leaseholder-detail ref="holderDetailRef"></leaseholder-detail>
        </div>
        <div v-if="childShow">
            <component v-bind:is="currentChild" :paramsData="currentData" @onFinish="onFinish"></component>
        </div>
    </div>
</template>

<script>
import tableTitle from '@/components/tableTitle/tableTitle.vue'
import dataGrid from '@/components/datagrid.vue'
import dictSelect from '@/components/select/dict-select.vue'
import targetTypeSelect from '@/components/select/targetTypeSelect'

import newFrameRentEnt from './newFrameRentEnt.vue'
import leaseholderDetail from './component/leaseholderDetail'


export default {
    components: { tableTitle, dataGrid, newFrameRentEnt, leaseholderDetail, dictSelect, targetTypeSelect },
    data() {
        return {
            confirmButton: false,
            tatbleShow: true,
            childShow: false,
            currentData: "",
            currentChild: "",
            queryUrl: "CORE-CONTRACT/messageService/queryService/queryFrameRentListByParam",
            queryParams: {
                memberId: "",
                targetType: ""
            },
            frameRentCols: [
                { title: '框架协议编号', slot: 'id' },
                { title: '计价模型编号', key: 'billingModelId', },
                { title: '模型名称', key: 'modelId', dict: ['default', 'billingModel', true] },
                { title: '计价模型名称', key: 'name' },
                { title: '参与人', key: 'memberId', dict: ['bizObjects', 'member', true] },
                { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true] },
                { title: '约定期限', key: 'rentTerm' },
                { title: '是否默认框架协议', key: 'defaultFlag', dict: ['default', 'bitYesNo'] },
                { title: '计费模式类型', key: 'billingModeType', dict: ['default', 'billingModeType'] },
                { title: '动态策略编号', key: 'strategyId' },
                { title: '生效日期', key: 'validDate', formatter: 'date' },
                { title: '失效日期', key: 'invalidDate', formatter: 'date' },

            ]
        }
    },
    mounted() {
        this.getButton()
    },
    methods: {
        getButton() {
            this.confirmButton = JSON.parse(sessionStorage.getItem('menuList')).some(item => item === 'leaseholderListMenuNewButton');
        },
        search() {
            this.$refs['lg'].loadFirstPage()
        },
        goDetail(id) {
            this.$refs['holderDetailRef'].openModal(id)
        },

        onFinish() {
            // this.search()
            this.childShow = false
        },
        // 新增框架协议
        onAddFrameRentEnt() {
            this.childShow = true;
            this.currentChild = newFrameRentEnt

        }
    }

}
</script>

<style lang="scss" scoped>
.hoverCollection:hover {
    text-decoration: underline;
}
</style>